module.exports = __webpack_public_path__ + "static/media/08.cab10d2b.png";